export const environment = {
  production: true,
  apiHost: 'https://makpak.allianz.de/prod/edge',
  apiUrl: 'api',
  backUrl: 'https://makler.allianz.de',
  useCiam: true,
  ciamUrl: 'https://login.allianz.de/auth/oauth2/realms/root/realms/bid1/authorize?client_id=0sd5m3v7p5qbae0a7g65lhp96s8w7zmkwv3d8hww&scope=token_exchange_pers%20company%20address%20az_role%20az_basic%20birthdate%20email%20phone_number%20profile%20openid&redirect_uri=https://makpak.allianz.de/auth/cim&response_type=code&state=1234567',
  ciamRedirect: 'https://makpak.allianz.de/auth/cim'
};
